export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index2.vue'),
        meta: {
            layout: 'full',
        },
    },
]